import { render } from "./BaseSpinner.vue?vue&type=template&id=22092008&scoped=true"
import script from "./BaseSpinner.vue?vue&type=script&lang=js"
export * from "./BaseSpinner.vue?vue&type=script&lang=js"

import "./BaseSpinner.vue?vue&type=style&index=0&id=22092008&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22092008"],['__file',"src/components/BaseSpinner.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "22092008"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('22092008', __exports__)) {
    api.reload('22092008', __exports__)
  }
  
  module.hot.accept("./BaseSpinner.vue?vue&type=template&id=22092008&scoped=true", () => {
    api.rerender('22092008', render)
  })

}


export default __exports__